// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__EBQ9H","item":"Navigation_item__Q9MCe","link":"Navigation_link__GvYR9","icons":"Navigation_icons__Zji3F"};